import { loadView } from '@/router'

export default [
  {
    path: 'invoice',
    name: 'reports-invoice',
    component: loadView('Application/Reports/Invoice'),
    showInAlfred: true,
    alfredTitle: 'Reports - Invoice'
  }
]
